import { DatePicker, Input, Table, Modal, Button } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";

const Search = Input.Search;
const { RangePicker } = DatePicker;

class RomarketPaymentStat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      startDate: '',
      endDate: '',
      status: '',
      userIdx: '',
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  handleChangeDate = (value) => {
    if (value.length == 0) {
      this.setState({
        startDate: "",
        endDate: "",
      }, this.getList);
    }
    else {
      this.setState({
        startDate: value[0].format('YYYYMMDD'),
        endDate: value[1].format('YYYYMMDD'),
      }, this.getList);

    }
  };
  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.romarketPaymentStatList,[10,pageNum,this.state.startDate,this.state.endDate,this.state.status,this.state.userIdx],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };

  render() {
    const { tables } = this.state;
    const columns = [
      {
        title: "통계 날짜",
        dataIndex: "statDate",
        className: "support-column-number fs-15 lh-21",
        render: value => moment(value, 'YYYYMMDD').format('YYYY-MM-DD') // 날짜 형식을 변환
      },
      {
        title: "총금액(원)",
        dataIndex: "totalPrice",
        className: "support-column-number fs-15 lh-21",
        render: value => numberFormat(value)
      },
      {
        title: "평균코인가격(원)",
        dataIndex: "coinPrice",
        className: "support-column-number fs-15 lh-21",
        render: value => numberFormat(value)
      },
      {
        title: "코인결제(ROM)",
        dataIndex: "payAmount",
        className: "support-column-number fs-15 lh-21",
        render: value => value ? (value/1000000000).toFixed(4) : ''
      },
      {
        title: "채굴량(ROM)",
        dataIndex: "miningAmount",
        className: "support-column-number fs-15 lh-21",
        render: value => value ? (value/1000000000).toFixed(4) : ''
      },
      {
        title: "보상량(ROM)",
        dataIndex: "rewardAmount",
        className: "support-column-number fs-15 lh-21",
        render: value => value ? (value/1000000000).toFixed(4) : ''
      }
    ];
    

    return (
      <div>
        <div className="wrapper mt-35 width-1240" />
          <div className="flex-row flex-center" style={{paddingBottom: '10px', color: 'red'}}>
          </div>
          <div className="flex-row flex-center" style={{paddingBottom: '10px'}}>

            <RangePicker
                locale={locale}
                onChange={(date) => {
                  this.handleChangeDate(date);
                }}
              />
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.deleted ? "gray" : "")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default RomarketPaymentStat;
